"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _Message = _interopRequireDefault(require("./Message.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Message = function Message(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    text = _ref.text,
    type = _ref.type;
  var css = (0, _Message.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.message, "mco-form-message", {
      "mco-form-message-error": type === "error"
    }, className)
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: type
  }, text));
};
var _default = Message;
exports.default = _default;